import { useSelector } from "react-redux";

function CurrentUser() {
  const user = useSelector((state) => state.users.currentUser);

  return user;
}

export default CurrentUser;
